import React, { useMemo, useState, useEffect } from 'react';
import {
  Box, Typography, Button, Paper, Container, Chip, AppBar, Toolbar,
  FormControl, InputLabel, Select, MenuItem, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, TextField, InputAdornment, Grid,
  Card, CardActionArea, Breadcrumbs, Link, TableSortLabel, TablePagination,
  CircularProgress
} from '@mui/material';
import {
  Logout, Search, CheckCircle, RadioButtonUnchecked, NavigateNext,
  FolderOpen, Edit, Flag, Groups
} from '@mui/icons-material';
import { TABLE_COLUMNS } from './constants/config';
import { getComparator } from './utils/tableHelpers';
import { getAllUsersInSession, getUsersByIds } from '../../service/userService';
import { getLabelingStatusForStudents, getLabelerCountsForSession } from '../../service/labelingService';
import { getTelemetryEventsBySession } from '../workspace/service/telemetryService';

const SESSION_ID = 649;

const SESSION_CONFIG = {
  11357: { playerType: 'telemetry', vispiSessionId: 643 },
  11361: { playerType: 'telemetry', vispiSessionId: 643 },
  11385: { playerType: 'telemetry', vispiSessionId: 643 },
  11435: { playerType: 'telemetry', vispiSessionId: 643 },
  11699: { playerType: 'telemetry', vispiSessionId: 654 },
  11704: { playerType: 'telemetry', vispiSessionId: 654 },
  11739: { playerType: 'telemetry', vispiSessionId: 654 },
  11796: { playerType: 'telemetry', vispiSessionId: 654 },
  11778: { playerType: 'telemetry', vispiSessionId: 654 },
  11896: { playerType: 'telemetry', vispiSessionId: 660 },
  11878: { playerType: 'telemetry', vispiSessionId: 659 },
  11933: { playerType: 'telemetry', vispiSessionId: 659 },
  11879: { playerType: 'telemetry', vispiSessionId: 659 },
  12165: { playerType: 'telemetry', vispiSessionId: 658 },
  11932: { playerType: 'telemetry', vispiSessionId: 658 },
  11924: { playerType: 'telemetry', vispiSessionId: 658 },
  11620: { playerType: 'telemetry', vispiSessionId: 654 },
  11513: { playerType: 'telemetry', vispiSessionId: 654 },
  11514: { playerType: 'telemetry', vispiSessionId: 654 },
  11489: { playerType: 'telemetry', vispiSessionId: 654 },
  11541: { playerType: 'telemetry', vispiSessionId: 654 },
  11483: { playerType: 'telemetry', vispiSessionId: 654 },
  11657: { playerType: 'telemetry', vispiSessionId: 654 },
  11665: { playerType: 'telemetry', vispiSessionId: 654 },
  11485: { playerType: 'telemetry', vispiSessionId: 654 },
  11700: { playerType: 'telemetry', vispiSessionId: 654 },
  11755: { playerType: 'telemetry', vispiSessionId: 654 },
  11790: { playerType: 'telemetry', vispiSessionId: 654 },
  11773: { playerType: 'telemetry', vispiSessionId: 654 },
  11808: { playerType: 'telemetry', vispiSessionId: 654 },
  11713: { playerType: 'telemetry', vispiSessionId: 654 },
  11716: { playerType: 'telemetry', vispiSessionId: 654 },
  11725: { playerType: 'telemetry', vispiSessionId: 654 },
};

const USER_STUDY_SESSION_NAMES = {
  658: 'Rectangle Class',
  659: 'String Methods',
};

// Test Batch 5 entries (Batch 9) - includes duplicate user in different sessions
const TEST_BATCH_5_ENTRIES = [
  { userId: 11878, name: 'Guest_kb6vgej', vispiSessionId: 659 },
  { userId: 11933, name: 'Guest_uuzocr', vispiSessionId: 659 },
  { userId: 11879, name: 'Guest_yqwdr', vispiSessionId: 659 },
];

// Batch 6 entries (Batch 10) - includes duplicate user in different sessions
const BATCH_6_ENTRIES = [
  { userId: 12165, name: 'Guest_bbs468', vispiSessionId: 658 },
  { userId: 12165, name: 'Guest_bbs468', vispiSessionId: 659 },
  { userId: 11932, name: 'Guest_gf5tsl', vispiSessionId: 658 },
  { userId: 11924, name: 'Guest_snmf8j', vispiSessionId: 658 },
];

// Batch 7 entries (Batch 11) - Session 654
const BATCH_7_ENTRIES = [
  { userId: 11588, name: 'Guest_o02m5', vispiSessionId: 654 },
  { userId: 11612, name: 'Guest_781nyn', vispiSessionId: 654 },
  { userId: 11513, name: 'Guest_o2n4qml', vispiSessionId: 654 },
  { userId: 11514, name: 'Guest_1wgjt6', vispiSessionId: 654 },
  { userId: 11489, name: 'Guest_zp8tw', vispiSessionId: 654 },
  { userId: 11541, name: 'Guest_2dbtr', vispiSessionId: 654 },
  { userId: 11483, name: 'Guest_tedynb', vispiSessionId: 654 },
  { userId: 11657, name: 'Guest_joa8s9', vispiSessionId: 654 },
  { userId: 11665, name: 'Guest_oblo59', vispiSessionId: 654 },
  { userId: 11485, name: 'Guest_500og', vispiSessionId: 654 },
  { userId: 11700, name: 'Guest_a5q9bk', vispiSessionId: 654 },
  { userId: 11755, name: 'Guest_9gkwzl', vispiSessionId: 654 },
  { userId: 11790, name: 'Guest_cem04k', vispiSessionId: 654 },
  { userId: 11773, name: 'Guest_nqr4ha', vispiSessionId: 654 },
  { userId: 11796, name: 'Guest_331p9o', vispiSessionId: 654 },
  { userId: 11808, name: 'Guest_j63zwl', vispiSessionId: 654 },
  { userId: 11713, name: 'Guest_6sjn6w', vispiSessionId: 654 },
  { userId: 11716, name: 'Guest_h346b2', vispiSessionId: 654 },
  { userId: 11725, name: 'Guest_1hjjmh', vispiSessionId: 654 },
  { userId: 11718, name: 'Guest_xbl6wt', vispiSessionId: 654 },
  { userId: 11545, name: 'Guest_wr9qgb', vispiSessionId: 654 },
  { userId: 11556, name: 'Guest_nmbtt', vispiSessionId: 654 },
  { userId: 11562, name: 'Guest_v07qvh', vispiSessionId: 654 },
  { userId: 11695, name: 'Guest_k4xlsl', vispiSessionId: 654 },
  { userId: 11800, name: 'Guest_ufy1z', vispiSessionId: 654 },
  { userId: 11753, name: 'Guest_63er2i', vispiSessionId: 654 },
];

export default function QueueView({ currentUser, onLogout, onSelectSession, onOpenIRR }) {
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [labelingStatus, setLabelingStatus] = useState({});
  const [labelerCounts, setLabelerCounts] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [topicFilter, setTopicFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('student');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    const fetchStarredUsers = async () => {
      try {
        setLoading(true);
        const users = await getAllUsersInSession(SESSION_ID);
        const starredUsers = users.filter(u => u.is_starred);
        const batchSize = Math.ceil(starredUsers.length / 3);

        const transformedSessions = starredUsers.map((user, index) => ({
          id: user.id, vispiSessionId: SESSION_ID, studentUserId: user.id,
          student: `${user.first_name || ''} ${user.last_name || ''}`.trim() || user.email || `User ${user.id}`,
          email: user.email, topic: 'General', status: 'pending',
          batch: Math.floor(index / batchSize) + 1, userData: user
        }));

        // Test Batch 1 (Batch 4)
        const TEST_BATCH_USER_IDS = [11197, 11155, 11173];
        const testBatchSessions = TEST_BATCH_USER_IDS
          .map((userId, index) => {
            const session = transformedSessions.find(s => s.studentUserId === userId);
            if (!session) return null;
            return { ...session, batch: 4, isTestBatch: true, sortOrder: index };
          }).filter(Boolean);

        // Test Batch 2 (Batch 5)
        const TEST_BATCH_2_USER_IDS = [11201, 11217, 11225];
        const testBatch2Sessions = TEST_BATCH_2_USER_IDS
          .map((userId, index) => {
            const session = transformedSessions.find(s => s.studentUserId === userId);
            if (!session) return null;
            return { ...session, batch: 5, isTestBatch: true, sortOrder: index };
          }).filter(Boolean);

        // Test Batch 3 (Batch 6)
        const TEST_BATCH_3_USER_IDS = [11385, 11435, 11357, 11361];
        const TEST_BATCH_3_NAMES = { 11357: 'Guest_k5wiac', 11361: 'Guest_wpq9pt', 11385: 'Guest_qzkvho', 11435: 'Guest_ip1nd7' };
        const testBatch3Sessions = TEST_BATCH_3_USER_IDS
          .map((userId, index) => {
            const config = SESSION_CONFIG[userId] || {};
            const existingSession = transformedSessions.find(s => s.studentUserId === userId);
            if (existingSession) {
              return { ...existingSession, vispiSessionId: config.vispiSessionId || existingSession.vispiSessionId, batch: 6, isTestBatch: true, sortOrder: index };
            }
            return {
              id: userId, vispiSessionId: config.vispiSessionId || 643, studentUserId: userId,
              student: TEST_BATCH_3_NAMES[userId] || `Guest_${userId}`, email: '', topic: 'General',
              status: 'pending', batch: 6, isTestBatch: true, sortOrder: index,
              userData: { id: userId, first_name: TEST_BATCH_3_NAMES[userId] || `Guest_${userId}` }
            };
          }).filter(Boolean);

        // Test Batch 4 (Batch 7) - Session 654
        const TEST_BATCH_4_USER_IDS = [11718, 11714, 11556, 11588, 11498];
        const TEST_BATCH_4_NAMES = { 11718: 'Guest_xbl6wt', 11714: 'Guest_ho9f9n', 11556: 'Guest_nmbtt', 11588: 'Guest_o02m5', 11498: 'Guest_09z6sl' };
        const testBatch4Sessions = TEST_BATCH_4_USER_IDS
          .map((userId, index) => {
            const config = SESSION_CONFIG[userId] || {};
            const existingSession = transformedSessions.find(s => s.studentUserId === userId);
            if (existingSession) {
              return { ...existingSession, vispiSessionId: config.vispiSessionId || existingSession.vispiSessionId, batch: 7, isTestBatch: true, sortOrder: index };
            }
            return {
              id: userId, vispiSessionId: config.vispiSessionId || 654, studentUserId: userId,
              student: TEST_BATCH_4_NAMES[userId] || `Guest_${userId}`, email: '', topic: 'General',
              status: 'pending', batch: 7, isTestBatch: true, sortOrder: index,
              userData: { id: userId, first_name: TEST_BATCH_4_NAMES[userId] || `Guest_${userId}` }
            };
          }).filter(Boolean);

        // Test Batch 5 (Batch 9) - Telemetry sessions
        const testBatch5Sessions = TEST_BATCH_5_ENTRIES.map((entry, index) => ({
          id: entry.userId,
          vispiSessionId: entry.vispiSessionId,
          studentUserId: entry.userId,
          student: entry.name,
          email: '',
          topic: 'General',
          status: 'pending',
          batch: 9,
          isTestBatch: true,
          sortOrder: index,
          playerType: 'telemetry',
          userData: { id: entry.userId, first_name: entry.name }
        }));

        // Batch 6 (Batch 10) - Telemetry sessions, includes user in multiple sessions
        const batch6Sessions = BATCH_6_ENTRIES.map((entry, index) => ({
          id: entry.userId,
          vispiSessionId: entry.vispiSessionId,
          studentUserId: entry.userId,
          student: entry.name,
          email: '',
          topic: 'General',
          status: 'pending',
          batch: 10,
          isTestBatch: true,
          sortOrder: index,
          playerType: 'telemetry',
          userData: { id: entry.userId, first_name: entry.name }
        }));

        // Batch 7 (Batch 11) - Session 654
        const batch7Sessions = BATCH_7_ENTRIES.map((entry, index) => ({
          id: entry.userId,
          vispiSessionId: entry.vispiSessionId,
          studentUserId: entry.userId,
          student: entry.name,
          email: '',
          topic: 'General',
          status: 'pending',
          batch: 11,
          isTestBatch: true,
          sortOrder: index,
          playerType: 'telemetry',
          userData: { id: entry.userId, first_name: entry.name }
        }));

        // User Study Batch (Batch 8) - Sessions 658 & 659 via telemetry
        let userStudySessions = [];
        try {
          const [events658, events659] = await Promise.all([
            getTelemetryEventsBySession(658),
            getTelemetryEventsBySession(659)
          ]);

          const userIds658 = Object.keys(events658).map(Number);
          const userIds659 = Object.keys(events659).map(Number);
          const allUserIds = [...new Set([...userIds658, ...userIds659])];

          const userDetails = await getUsersByIds(allUserIds) || [];

          const combined = [
            ...userIds658.map(id => ({ id, fromSession: 658 })),
            ...userIds659.map(id => ({ id, fromSession: 659 }))
          ].sort((a, b) => b.id - a.id);

          userStudySessions = combined.map((entry, index) => {
            const user = userDetails.find(u => u.id === entry.id) || {};
            return {
              id: entry.id, vispiSessionId: entry.fromSession, studentUserId: entry.id,
              student: `${user.first_name || ''} ${user.last_name || ''}`.trim() || user.email || `User ${entry.id}`,
              email: user.email || '',
              topic: USER_STUDY_SESSION_NAMES[entry.fromSession] || `Session ${entry.fromSession}`,
              status: 'pending', batch: 8, isTestBatch: true, sortOrder: index,
              playerType: 'telemetry', userData: user
            };
          });
        } catch (err) {
          console.error('Error fetching user study sessions:', err);
        }

        const allSessions = [
          ...transformedSessions, ...testBatchSessions, ...testBatch2Sessions,
          ...testBatch3Sessions, ...testBatch4Sessions, ...testBatch5Sessions,
          ...batch6Sessions, ...batch7Sessions, ...userStudySessions
        ];
        setSessions(allSessions);

        // Fetch labeling status
        if (currentUser && allSessions.length > 0) {
          const studentUserIds = [...new Set(allSessions.map(s => s.studentUserId))];
          try {
            const [s649, s643, s654, s658, s659, s660, s661] = await Promise.all([
              getLabelingStatusForStudents(currentUser, 649, studentUserIds),
              getLabelingStatusForStudents(currentUser, 643, studentUserIds),
              getLabelingStatusForStudents(currentUser, 654, studentUserIds),
              getLabelingStatusForStudents(currentUser, 658, studentUserIds),
              getLabelingStatusForStudents(currentUser, 659, studentUserIds),
              getLabelingStatusForStudents(currentUser, 660, studentUserIds),
              getLabelingStatusForStudents(currentUser, 661, studentUserIds),
            ]);
            setLabelingStatus({ ...s649, ...s643, ...s654, ...s658, ...s659, ...s660, ...s661 });
          } catch (err) { console.error('Error fetching labeling status:', err); }
        }

        // Fetch labeler counts
        try {
          const [c649, c643, c654, c658, c659, c660, c661] = await Promise.all([
            getLabelerCountsForSession(649), getLabelerCountsForSession(643),
            getLabelerCountsForSession(654), getLabelerCountsForSession(658),
            getLabelerCountsForSession(659), getLabelerCountsForSession(660),
            getLabelerCountsForSession(661),
          ]);
          setLabelerCounts({ ...c649, ...c643, ...c654, ...c658, ...c659, ...c660, ...c661 });
        } catch (err) { console.error('Error fetching labeler counts:', err); }
      } catch (error) {
        console.error('Error fetching starred users:', error);
      } finally { setLoading(false); }
    };
    fetchStarredUsers();
  }, [currentUser]);

  const getSessionStatus = (session) => { const s = labelingStatus[session.studentUserId]; return s ? s.status : 'pending'; };
  const getSessionLabelingId = (session) => { const s = labelingStatus[session.studentUserId]; return s?.labelingSessionId || null; };
  const isSessionFlagged = (session) => { const s = labelingStatus[session.studentUserId]; return s?.isFlagged || false; };
  const getLabelerCount = (session) => { const c = labelerCounts[session.studentUserId]; return c?.count || 0; };
  const getLabelerNames = (session) => { const c = labelerCounts[session.studentUserId]; return c?.labelers || []; };

  const getUniqueTopics = (batchId) => [...new Set(sessions.filter(s => s.batch === batchId).map(s => s.topic))];
  const getUniqueStatuses = () => ['pending', 'in_progress', 'completed'];

  const filteredAndSortedSessions = useMemo(() => {
    if (!selectedBatch) return [];
    let filtered = sessions.filter(session => {
      const inBatch = session.batch === selectedBatch;
      const matchesSearch = session.student.toLowerCase().includes(searchTerm.toLowerCase()) || session.id.toString().includes(searchTerm);
      const matchesTopic = !topicFilter || session.topic === topicFilter;
      const matchesStatus = !statusFilter || getSessionStatus(session) === statusFilter;
      return inBatch && matchesSearch && matchesTopic && matchesStatus;
    });
    if ([4, 5, 6, 7, 8, 9, 10, 11].includes(selectedBatch)) {
      filtered = filtered.sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
    } else {
      filtered = filtered.sort(getComparator(order, orderBy));
    }
    return filtered;
  }, [sessions, searchTerm, selectedBatch, topicFilter, statusFilter, order, orderBy, labelingStatus]);

  const paginatedSessions = useMemo(() => {
    return filteredAndSortedSessions.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  }, [filteredAndSortedSessions, page, rowsPerPage]);

  const handleFilterChange = (setter) => (value) => { setter(value); setPage(0); };
  const handleRequestSort = (property) => { setOrder(orderBy === property && order === 'asc' ? 'desc' : 'asc'); setOrderBy(property); };
  const handleChangePage = (_, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); };

  const getBatchStats = (batchId) => {
    const b = sessions.filter(s => s.batch === batchId);
    return { total: b.length, completed: b.filter(s => getSessionStatus(s) === 'completed').length, inProgress: b.filter(s => getSessionStatus(s) === 'in_progress').length };
  };

  const handleBackToBatches = () => { setSelectedBatch(null); setPage(0); setTopicFilter(''); setStatusFilter(''); setSearchTerm(''); };

  const getBatchTitle = (batchId) => {
    if (batchId === 4) return 'Test Batch 1';
    if (batchId === 5) return 'Test Batch 2';
    if (batchId === 6) return 'Test Batch 3';
    if (batchId === 7) return 'Test Batch 4';
    if (batchId === 8) return 'User Study';
    if (batchId === 9) return 'Batch 5';
    if (batchId === 10) return 'Batch 6';
    if (batchId === 11) return 'Batch 7';
    return `Batch #${batchId}`;
  };

  const handleSelectSession = (session) => {
    const config = SESSION_CONFIG[session.studentUserId] || {};
    onSelectSession({
      ...session,
      vispiSessionId: session.vispiSessionId || config.vispiSessionId || SESSION_ID,
      studentUserId: session.studentUserId,
      labelingSessionId: getSessionLabelingId(session),
      batchId: session.batch,
      playerType: session.playerType || config.playerType || 'telemetry'
    });
  };

  const handleOpenIRR = (session) => {
    const config = SESSION_CONFIG[session.studentUserId] || {};
    onOpenIRR({
      vispiSessionId: session.vispiSessionId || config.vispiSessionId || SESSION_ID,
      studentUserId: session.studentUserId,
      studentName: session.student,
      labelerCount: getLabelerCount(session),
      labelers: getLabelerNames(session)
    });
  };

  const renderStatusChip = (session) => {
    const status = getSessionStatus(session);
    const isFlagged = isSessionFlagged(session);
    if (status === 'completed') {
      return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Chip icon={<CheckCircle style={{ fontSize: 16 }} />} label="Reviewed" size="small" color="success" variant="outlined" sx={{ borderRadius: 1, fontWeight: 600, bgcolor: '#f0fdf4', borderColor: '#bbf7d0', color: '#166534' }} />
          {isFlagged && <Flag sx={{ fontSize: 16, color: '#f59e0b' }} />}
        </Box>
      );
    } else if (status === 'in_progress') {
      return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Chip icon={<Edit style={{ fontSize: 16 }} />} label="In Progress" size="small" color="warning" variant="outlined" sx={{ borderRadius: 1, fontWeight: 600, bgcolor: '#fffbeb', borderColor: '#fcd34d', color: '#92400e' }} />
          {isFlagged && <Flag sx={{ fontSize: 16, color: '#f59e0b' }} />}
        </Box>
      );
    }
    return <Chip icon={<RadioButtonUnchecked style={{ fontSize: 16 }} />} label="Pending" size="small" variant="outlined" sx={{ borderRadius: 1, fontWeight: 600, bgcolor: '#f9fafb', borderColor: '#e5e7eb', color: '#6b7280' }} />;
  };

  const renderReviewColumn = (session) => {
    const count = getLabelerCount(session);
    const labelers = getLabelerNames(session);
    if (count < 2) return <Typography variant="body2" sx={{ color: '#d1d5db' }}>—</Typography>;
    return (
      <Button variant="outlined" size="small" startIcon={<Groups sx={{ fontSize: 16 }} />}
        onClick={() => handleOpenIRR(session)}
        title={labelers.map(l => `${l.name} (${l.status})`).join(', ')}
        sx={{ textTransform: 'none', borderColor: '#8b5cf6', color: '#7c3aed', borderRadius: 2, fontWeight: 600, '&:hover': { bgcolor: '#f5f3ff', borderColor: '#7c3aed' } }}>
        IRR {count}
      </Button>
    );
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#ffffff' }}>
      <AppBar position="static" color="transparent" elevation={0} sx={{ borderBottom: '1px solid #e5e7eb' }}>
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          <Typography variant="h6" fontWeight="bold" sx={{ color: '#111827' }}>VizPI Labeler</Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Typography variant="body2" sx={{ color: '#6b7280' }}>
              Logged in as <strong style={{ color: '#111827' }}>{currentUser}</strong>
            </Typography>
            <Button startIcon={<Logout />} size="small" onClick={onLogout} sx={{ color: '#6b7280', textTransform: 'none' }}>Exit</Button>
          </Box>
        </Toolbar>
      </AppBar>

      <Container maxWidth="lg" sx={{ py: 4 }}>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}><CircularProgress /></Box>
        ) : (
        <>
        <Box sx={{ mb: 4 }}>
          <Breadcrumbs separator={<NavigateNext fontSize="small" />}>
            <Link underline="hover" color="inherit" onClick={handleBackToBatches}
              sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center', fontWeight: !selectedBatch ? 700 : 400, color: !selectedBatch ? '#111827' : '#6b7280' }}>
              <FolderOpen sx={{ mr: 0.5, fontSize: 20 }} /> Batches
            </Link>
            {selectedBatch && <Typography color="text.primary" fontWeight="700">{getBatchTitle(selectedBatch)}</Typography>}
          </Breadcrumbs>
        </Box>

        {!selectedBatch ? (
          <>
            <Typography variant="h5" fontWeight="600" sx={{ mb: 1, color: '#111827' }}>Select a Batch</Typography>
            <Typography variant="body2" sx={{ mb: 4, color: '#6b7280' }}>Choose a data batch to start labeling sessions.</Typography>
            <Grid container spacing={3}>
              {[4, 5, 6, 7, 9, 10, 11, 8].map((batchId) => {
                const stats = getBatchStats(batchId);
                return (
                  <Grid item xs={12} md={3} key={batchId}>
                    <Card elevation={0} sx={{ border: '1px solid #e5e7eb', borderRadius: 3, transition: '0.2s', '&:hover': { borderColor: '#000', transform: 'translateY(-2px)' } }}>
                      <CardActionArea onClick={() => { setSelectedBatch(batchId); setPage(0); }} sx={{ p: 3, height: '100%' }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                          <Box sx={{ width: 40, height: 40, bgcolor: '#f3f4f6', borderRadius: 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <FolderOpen sx={{ color: '#374151' }} />
                          </Box>
                          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 0.5 }}>
                            <Chip label={`${stats.completed}/${stats.total} Done`} size="small" color={stats.completed === stats.total && stats.total > 0 ? "success" : "default"} sx={{ fontWeight: 600, borderRadius: 1 }} />
                            {stats.inProgress > 0 && <Typography variant="caption" sx={{ color: '#f59e0b', fontWeight: 500 }}>{stats.inProgress} in progress</Typography>}
                          </Box>
                        </Box>
                        <Typography variant="h6" fontWeight="700">{getBatchTitle(batchId)}</Typography>
                        <Typography variant="body2" color="text.secondary">Contains {stats.total} sessions ready for review.</Typography>
                      </CardActionArea>
                    </Card>
                  </Grid>
                );
              })}
            </Grid>
          </>
        ) : (
          <>
            <Box sx={{ mb: 3 }}>
              <Typography variant="h5" fontWeight="600" sx={{ color: '#111827' }}>{getBatchTitle(selectedBatch)} Sessions</Typography>
              <Typography variant="body2" sx={{ color: '#6b7280' }}>Select a session to begin analysis. Click column headers to sort.</Typography>
            </Box>

            <Paper elevation={0} sx={{ p: 2, mb: 3, border: '1px solid #e5e7eb', borderRadius: 2, bgcolor: '#f9fafb' }}>
              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
                <TextField placeholder="Search sessions..." size="small" value={searchTerm}
                  onChange={(e) => handleFilterChange(setSearchTerm)(e.target.value)}
                  InputProps={{ startAdornment: <InputAdornment position="start"><Search fontSize="small" sx={{ color: '#9ca3af' }} /></InputAdornment> }}
                  sx={{ minWidth: 250, '& .MuiOutlinedInput-root': { borderRadius: 2, bgcolor: 'white', '& fieldset': { borderColor: '#e5e7eb' }, '&:hover fieldset': { borderColor: '#d1d5db' } } }} />
                <FormControl size="small" sx={{ minWidth: 140 }}>
                  <InputLabel sx={{ bgcolor: '#f9fafb', px: 0.5 }}>Topic</InputLabel>
                  <Select value={topicFilter} label="Topic" onChange={(e) => handleFilterChange(setTopicFilter)(e.target.value)}
                    sx={{ borderRadius: 2, bgcolor: 'white', '& fieldset': { borderColor: '#e5e7eb' } }}>
                    <MenuItem value="">All Topics</MenuItem>
                    {getUniqueTopics(selectedBatch).map((topic) => <MenuItem key={topic} value={topic}>{topic}</MenuItem>)}
                  </Select>
                </FormControl>
                <FormControl size="small" sx={{ minWidth: 140 }}>
                  <InputLabel sx={{ bgcolor: '#f9fafb', px: 0.5 }}>Status</InputLabel>
                  <Select value={statusFilter} label="Status" onChange={(e) => handleFilterChange(setStatusFilter)(e.target.value)}
                    sx={{ borderRadius: 2, bgcolor: 'white', '& fieldset': { borderColor: '#e5e7eb' } }}>
                    <MenuItem value="">All Status</MenuItem>
                    {getUniqueStatuses().map((status) => <MenuItem key={status} value={status} sx={{ textTransform: 'capitalize' }}>{status === 'in_progress' ? 'In Progress' : status.charAt(0).toUpperCase() + status.slice(1)}</MenuItem>)}
                  </Select>
                </FormControl>
                {(searchTerm || topicFilter || statusFilter) && (
                  <Button size="small" onClick={() => { setSearchTerm(''); setTopicFilter(''); setStatusFilter(''); setPage(0); }}
                    sx={{ textTransform: 'none', color: '#6b7280', '&:hover': { bgcolor: '#f3f4f6' } }}>Clear filters</Button>
                )}
                <Box sx={{ ml: 'auto' }}>
                  <Typography variant="body2" sx={{ color: '#6b7280' }}>{filteredAndSortedSessions.length} session{filteredAndSortedSessions.length !== 1 ? 's' : ''} found</Typography>
                </Box>
              </Box>
            </Paper>

            <TableContainer component={Paper} elevation={0} sx={{ marginTop: '-6px' }}>
              <Table>
                <TableHead sx={{ bgcolor: '#f9fafb' }}>
                  <TableRow>
                    {TABLE_COLUMNS.map((column) => (
                      <TableCell key={column.id} align={column.align || 'left'}
                        sx={{ fontWeight: 600, color: '#6b7280', fontSize: '0.85rem', textTransform: 'uppercase', borderBottom: '1px solid #e5e7eb' }}>
                        {column.sortable && ![4, 5, 6, 7, 8, 9, 10, 11].includes(selectedBatch) ? (
                          <TableSortLabel active={orderBy === column.id} direction={orderBy === column.id ? order : 'asc'} onClick={() => handleRequestSort(column.id)}
                            sx={{ '&.Mui-active': { color: '#111827' }, '& .MuiTableSortLabel-icon': { color: '#6b7280 !important' } }}>
                            {column.label}
                          </TableSortLabel>
                        ) : column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paginatedSessions.map((session) => (
                    <TableRow key={`${session.id}-${session.batch}-${session.vispiSessionId}`}
                      sx={{ '&:hover': { bgcolor: '#f9fafb' }, '& td': { borderLeft: 'none !important' } }}>
                      <TableCell>
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                          <Typography variant="subtitle2" fontWeight="600" color="#111827">{session.student}</Typography>
                          <Typography variant="caption" color="#9ca3af">ID: {session.studentUserId} • Session: {session.vispiSessionId}</Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Chip label={session.topic} size="small" sx={{ bgcolor: '#f3f4f6', color: '#374151', fontWeight: 500, borderRadius: 1 }} />
                      </TableCell>
                      <TableCell>{renderStatusChip(session)}</TableCell>
                      <TableCell>{renderReviewColumn(session)}</TableCell>
                      <TableCell align="center">
                        <Button variant="outlined" size="small" onClick={() => handleSelectSession(session)}
                          sx={{ textTransform: 'none', borderColor: '#e5e7eb', color: '#374151', borderRadius: 2, fontWeight: 500, '&:hover': { bgcolor: '#f9fafb', borderColor: '#d1d5db', color: '#111827' } }}>
                          {getSessionStatus(session) === 'in_progress' ? 'Continue' : 'Open Studio'}
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                  {paginatedSessions.length === 0 && (
                    <TableRow><TableCell colSpan={5} align="center" sx={{ py: 8, color: '#6b7280' }}>No sessions found matching your filters.</TableCell></TableRow>
                  )}
                </TableBody>
              </Table>
              <TablePagination component="div" count={filteredAndSortedSessions.length} page={page}
                onPageChange={handleChangePage} rowsPerPage={rowsPerPage} onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[5, 10, 25]}
                sx={{ borderTop: '1px solid #e5e7eb', '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': { color: '#6b7280', fontSize: '0.875rem' }, '.MuiTablePagination-select': { color: '#374151' } }} />
            </TableContainer>
          </>
        )}
        </>
        )}
      </Container>
    </Box>
  );
}